import { render, staticRenderFns } from "./client-table.vue?vue&type=template&id=6b588964"
import script from "./client-table.vue?vue&type=script&lang=js"
export * from "./client-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports